import React, { FC, useEffect, useState } from 'react';
import { Button } from 'antd';

import styles from './CookieBanner.module.css';

const STORAGE_KEY = 'rgpd_consent';

export const CookieBanner: FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(STORAGE_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        Nous utilisons des cookies pour améliorer votre expérience. En continuant à
        utiliser cette application, vous acceptez notre politique de confidentialité
        conformément au RGPD (Règlement européen n°2016/679/UE).
      </p>
      <div className={styles.actions}>
        <Button onClick={handleRefuse}>Refuser</Button>
        <Button type="primary" onClick={handleAccept}>
          Accepter
        </Button>
      </div>
    </div>
  );
};
